import { render, staticRenderFns } from "./Error423.vue?vue&type=template&id=ff9d0944&scoped=true&lang=pug&"
import script from "./Error423.vue?vue&type=script&lang=ts&"
export * from "./Error423.vue?vue&type=script&lang=ts&"
import style0 from "./Error423.vue?vue&type=style&index=0&id=ff9d0944&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9d0944",
  null
  
)

export default component.exports